// -----------------------------------------------------------------------------
// Library
// -----------------------------------------------------------------------------
import React from "react";
import { Card, Typography } from "antd";

// -----------------------------------------------------------------------------
// Components, utils and Styles
// -----------------------------------------------------------------------------
import { convertFalsyToUndefined } from "helpers/generic";
import ImageUpload from "components/ImageUpload";
import StyledImageInputCard from "./styles";

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------
const ImageInputCard = ({ title, subtitle, description, imageUrl, onSaveImage, sizeLimit, hideText, onCancel }) => {
	return (
		<StyledImageInputCard>
			<Card hoverable bordered className="sb-image-input-card">
				<div className="sb-image-input-card__left">
					<Typography.Title className="sb-image-input-card__left__title">{title}</Typography.Title>
					<Typography.Paragraph className="sb-image-input-card__left__subtitle">{subtitle}</Typography.Paragraph>
					<Typography.Paragraph className="sb-image-input-card__left__description">{description}</Typography.Paragraph>
				</div>
				<div className="sb-image-input-card__right">
					<ImageUpload
						aspectRatio={1}
						dimensions={{ width: "80px", height: "80px" }}
						preImage={convertFalsyToUndefined(imageUrl)}
						onSave={onSaveImage}
						sizeLimit={sizeLimit}
						onCancel={onCancel}
						hideText={hideText}
					/>
				</div>
			</Card>
		</StyledImageInputCard>
	);
};

export default ImageInputCard;

